import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Login from "./components/auth/login";
import Register from "./components/auth/register";
import PrivateRoute from "./components/auth/PrivateRoute";
import Issue from "./components/other-components/issue/IssuePending";
import IssueAccept from "./components/other-components/issue/IssueAccept";
import IssueResolve from "./components/other-components/issue/IssueResolved";
import Management from "./components/other-components/management/management";
import Appliances from "./components/other-components/appliances/appliances";
import AddAppliances from "./components/other-components/appliances/addAppliance";
import ViewAppliance from "./components/other-components/appliances/ViewAppliance";
import EditAppliance from "./components/other-components/appliances/editAppliance";
import Vendors from "./components/other-components/vendors/vendors";
import IssueRejected from "./components/other-components/issue/IssueRejected";
import User from "./components/other-components/user/userIssues";
import Brands from "./components/other-components/brands/Brands";

function App() {
  const loggedIn = localStorage.getItem("_token");
  return (
    <BrowserRouter>
      <Routes>
        {/* <Route path="/" element={loggedIn ? <Navigate replace to="/management"/> : <Login />} />
        <Route path="/login" element={loggedIn ? <Navigate replace to="/management"/> : <Login />} /> */}
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="/reg" element={<Register />} />
      </Routes>

      {/* <Sidebar />
      <Header /> */}
      <Routes>
        <Route
          path="/issue"
          element={
            <PrivateRoute role={"Admin"}>
              <Issue />
            </PrivateRoute>
          }
        />
        <Route
          path="/issueaccept"
          element={
            <PrivateRoute role={"Admin"}>
              <IssueAccept />
            </PrivateRoute>
          }
        />
        <Route
          path="/issueresolve"
          element={
            <PrivateRoute role={"Admin"}>
              <IssueResolve />
            </PrivateRoute>
          }
        />
        <Route
          path="/issuerejected"
          element={
            <PrivateRoute role={"Admin"}>
              <IssueRejected />
            </PrivateRoute>
          }
        />
        <Route
          path="/management"
          element={
            <PrivateRoute role={"Admin"}>
              <Management />
            </PrivateRoute>
          }
        />
        <Route
          path="/brands"
          element={
            <PrivateRoute role={"Admin"}>
              <Brands />
            </PrivateRoute>
          }
        />

        <Route
          path="/appliances"
          element={
            <PrivateRoute role={"Admin"}>
              <Appliances />
            </PrivateRoute>
          }
        />
        <Route
          path="/add-appliances"
          element={
            <PrivateRoute role={"Admin"}>
              <AddAppliances />
            </PrivateRoute>
          }
        />
        <Route
          path="/edit-appliances/:id"
          element={
            <PrivateRoute role={"Admin"}>
              <EditAppliance />
            </PrivateRoute>
          }
        />
        <Route
          path="/view-appliances/:id"
          element={
            <PrivateRoute role={"Admin"}>
              <ViewAppliance />
            </PrivateRoute>
          }
        />

        <Route
          path="/vendors"
          element={
            <PrivateRoute role={"Admin"}>
              <Vendors />
            </PrivateRoute>
          }
        />
        <Route
          path="/user"
          element={
            <PrivateRoute role={"Employee"}>
              <User />
            </PrivateRoute>
          }
        />
      </Routes>
      {/* <Footer /> */}
    </BrowserRouter>
  );
}

export default App;
